import {Component, Injector, OnInit} from '@angular/core';
import {BasePropostaComponent} from '../base-proposta';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Helper} from 'src/app/shared/helpers/helper';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AppComponent} from '../../../app.component';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {RdService} from '../../../core/services/rd.service';
import {CupomService} from '../../../core/services/cupom.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {CepService} from '../../../core/services/cep.service';
import {Meta, Title} from '@angular/platform-browser';
import {ProdutoService} from '../../../core/services/produto.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-pagamento-credito',
    templateUrl: './pagamento-credito.component.html',
    styleUrls: ['./pagamento-credito.component.sass']
})
export class PagamentoCreditoComponent extends BasePropostaComponent implements OnInit {
    public form: FormGroup;
    public bandeiraCartao: string;
    public mask: string;
    propostaCredito = false;

    constructor(
        protected injector: Injector,
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        public helperService: Helper,
        public formBuilder: FormBuilder,
        public cepService: CepService,
        public rdService: RdService,
        public toast: ToastrService,
        public categoriaPlanoService: CategoriaPlanoService,
        public appComponent: AppComponent,
        public titleService: Title,
        public meta: Meta,
        public produtoService: ProdutoService,
        public deviceService: DeviceDetectorService,
    ) {
        super(injector);

        const proposta = this.getPropostaParaStorage();
        this.propostaCredito = (proposta !== null && proposta.cartaoTitular !== undefined);

        this.form = formBuilder.group({
            cartaoTitular: new FormControl(proposta ? proposta.cartaoTitular : null, [Validators.required]),
            cartaoValidade: new FormControl(proposta ? proposta.cartaoValidade : null, [Validators.required]),
            cartaoBandeira: new FormControl(proposta ? proposta.cartaoBandeira : null, [Validators.required]),
            cartaoNumero: new FormControl(proposta ? proposta.cartaoNumero : null, [Validators.required]),
            // cartaoCVC: new FormControl(proposta ? proposta.cartaoCVC : null, [Validators.required]),
            bairro: new FormControl(proposta ? proposta.bairro : null, [Validators.required]),
            cep: new FormControl(proposta ? proposta.cep : null, [Validators.required]),
            codCidade: new FormControl(proposta ? proposta.codCidade : null, [Validators.required]),
            complemento: new FormControl(proposta ? proposta.complemento : null, []),
            logradouro: new FormControl(proposta ? proposta.logradouro : null, [Validators.required]),
            numero: new FormControl(proposta ? proposta.numero : null, [Validators.required]),
            termoDeUsoAceito: new FormControl(null, [Validators.required]),
        });

        this.carregarEnderecoLocalStorage(this.form);
    }

    termoDeUsoAceitoEmit($event) {
        this.form.get('termoDeUsoAceito').setValue($event ? true : null);
    }

    showError(campo) {
        return this.form.controls[campo].errors && !this.form.controls[campo].pristine;
    }

    getErrorMessage(field: string) {

        const input = this.form.get(field);
        return input.hasError('required') ? 'Campo obrigatório' :
            input.hasError('cpf') ? 'CPF inválido' :
                input.hasError('invalidDate') ? 'Insira uma data válida.' :
                    input.hasError('notSame') ? 'E-mail não confere.' :
                        input.hasError('email') ? 'E-mail inválido.' :
                            input.hasError('mask') ? 'Insira um formato valido: ' + input.errors.mask.requiredMask :
                                input.hasError('cepIncorrect') ? 'CEP inválido' :
                            '';
    }

    async submit() {
        if (this.form.valid) {
            const data = this.form.value;
            data.cartaoValidade = data.cartaoValidade.substr(0, 2) + '/' + data.cartaoValidade.substr(2, 4);

            const result = await this.propostaService.pagamentoCartaoCredito(this.form.value);

            if (result.status === 200 || result.status === 201) {
                const credCardData = this.form.value;
                delete credCardData.cartaoCVC;
                delete credCardData.cartaoBandeira;
                delete credCardData.cartaoNumero;

                const nomeTitular = this.form.get('cartaoTitular').value;
                const numeroCartao = this.form.get('cartaoNumero').value;
                const dataVencimentoCartao = this.form.get('cartaoValidade').value;
                const bairro = this.form.get('bairro').value;
                const cep = this.form.get('cep').value;
                const complemento = this.form.get('complemento').value;
                const endereco = this.form.get('logradouro').value;
                const numero = this.form.get('numero').value;
                await this.rdService.carrinhoPasso3(
                    this.emailCliente,
                    nomeTitular,
                    numeroCartao,
                    dataVencimentoCartao,
                    bairro,
                    cep,
                    complemento,
                    endereco,
                    numero
                );
                this.addPropostaParaStorage(credCardData);
                await this.router.navigate(['seguranca']);
            } else if (result.status === 400 || result.status === 409) {
                this.toast.error(result.error.description);
            } else {
                this.toast.error('Ocorreu um erro ao processar a requisição', '', {
                    timeOut: 5000
                });
            }
        }
    }

    async ngOnInit() {
        await this.inOnInit();
        this.mask = '0000 0000 0000 0099';
    }

    validarFlagCartao() {
        const cartaoNumero = this.form.get('cartaoNumero').value;
        if (cartaoNumero && cartaoNumero.length >= 14) {
            this.bandeiraCartao = this.helperService.pegarFlagCartao(cartaoNumero);
            if (!this.bandeiraCartao) {
                this.toast.error('Bandeira de cartão de credito não permitida!');
                this.bandeiraCartao = 'NS';
            }
            this.form.get('cartaoBandeira').setValue(this.bandeiraCartao);
            if (cartaoNumero.length === 14) {
                this.mask = '0000 000000 0000';
            }
            if (cartaoNumero.length === 15) {
                this.mask = '0000 000000 00000';
            }
        } else {
            this.bandeiraCartao = '';
        }
    }
}
